
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.208 12.208a.9.9 0 01-1.096.003l-.092-.082-.075-.085a.9.9 0 01-.003-1.095l.082-.093 1.867-1.855L3 9a1 1 0 01-.117-1.993L3 7h7.772L8.93 5.139l-.074-.085a.9.9 0 011.262-1.262l.092.081 3.53 3.569.074.085a.9.9 0 01.002 1.094l-.082.092-3.441 3.421-.085.075z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    